var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner",style:({ height: `${_vm.spinnerSize}px`, width: `${_vm.spinnerSize}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }